import Fuse from './fuse-custom-6.4.6/fuse.basic.esm.min.js';

export default class FAQ {
  constructor(element) {
    this.passedElement = element;
    this.searchQuery = "";
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.getElements();
      this.initialiseQuestionDataObject();
      this.initFuse();
      this.addEventListeners();
    }
  }

  getElements = () => {
    this.searchInput = document.querySelector(".js-faq-search");
    this.questionElements = document.querySelectorAll(".rf-question");
    this.groupElements = document.querySelectorAll(".rf-faq__group");
    this.clearButton = document.querySelector('.js-search-clear');

    this.noResults = document.querySelector('.js-no-results');
    this.searchTerm = document.querySelector('.js-search-term');
  }

  handleClearClick = () => {
    this.searchInput.value = "";
    this.searchQuery = "";
    this.clearButton.classList.remove('show');
    this.handleSearchInput(null, true);
  }

  initialiseQuestionDataObject = () => {
    let searchPossibilities = [];

    this.questionElements.forEach((item, i) => {
      let title = item.querySelector(".rf-question__title").innerText.toLowerCase();
      let element = item;

      let dataObject = {
        title: title,
        element: element,
      };
      searchPossibilities.push(dataObject);
    });

    this.list = searchPossibilities;
  }


  initFuse = () => {
    const options = {
      keys: ['title'],
      threshold: 0.2,
      ignoreLocation: true,
    }

    this.fuseSearch = new Fuse(this.list, options);
  }

  handleSearchInput = (e, cleared = false) => {
    this.searchQuery = (cleared) ? "" : e.target.value;

    if (!this.searchQuery.length) {
      this.questionElements.forEach((item, i) => {
        item.classList.remove("hide");
      });

      this.clearButton.classList.remove('show');
      this.noResults.style.display = "none";

    } else {
      const results = this.fuseSearch.search(this.searchQuery.toLowerCase());

      if (!results.length) {
        this.noResults.style.display = "block";
        this.searchTerm.innerHTML = this.searchQuery;
      } else {
        this.noResults.style.display = "none";
      }

      this.clearButton.classList.add('show');

      // hide every single question
      this.questionElements.forEach((item, i) => {
        item.classList.add("hide");
      });

      // Reveal the matching questions
      results.forEach((matchingQuestion, i) => {
        matchingQuestion.item.element.classList.remove("hide");
      });
    }
    this.hideAnyGroupLabelsWithNoChildren();
  }

  hideAnyGroupLabelsWithNoChildren = () => {

    this.groupElements.forEach((item, i) => {


      let questions = item.querySelectorAll(".rf-question");
      let slug = item.getAttribute("data-group-slug");
      let navLink = document.querySelector(`[href="#${slug}"]`);
      let hasActive = false;

      questions.forEach((el, i) => {
        if (!el.classList.contains("hide")) {
          hasActive = true;
        }
      });

      if (hasActive) {
        item.classList.remove("hide");
        navLink.classList.remove("hide");
      } else {
        item.classList.add("hide");
        navLink.classList.add("hide");
      }
    });

  }

  addEventListeners = () => {
    this.searchInput.addEventListener('keyup', this.handleSearchInput);
    this.clearButton.addEventListener('click', this.handleClearClick);
  }

  removeEventListeners = () => {
  }

  dismantle = () => {
  }

}
